import { useEffect, type ReactNode } from 'react'
import useAuthStore from '@/store/useAuthStore'
import useBillingStore from '@/store/useBillingStore'
import useGetBillingSubscription from '@/services/api/billing/useGetBillingSubscription'
import BillingBlockedScreen from './BillingBlockedScreen'

/**
 * Renders the billing recovery screen whenever the httpClient interceptor has
 * flagged a subscription-level 421 (codes 0-3). Auto-clears once the current
 * space's billing looks healthy again (e.g. after switching spaces).
 */
export default function BillingBlockGate({ children }: { children: ReactNode }) {
  const block = useBillingStore((s) => s.block)
  const clearBlock = useBillingStore((s) => s.clearBlock)
  const currentTeamId = useAuthStore((s) => s.currentTeamId)

  const { data, isSuccess } = useGetBillingSubscription({
    teamId: currentTeamId,
    enabled: !!block,
    refetchOnMount: 'always',
  })

  useEffect(() => {
    if (block && isSuccess && data?.has_active_subscription) {
      clearBlock()
    }
  }, [block, isSuccess, data?.has_active_subscription, clearBlock])

  if (block) return <BillingBlockedScreen block={block} />

  return <>{children}</>
}
